import React from 'react';
import { Tooltip } from '@material-ui/core';
import './main.css';
import chartRow from '../images/ZlvsWalkme Rows.svg';
import check from '../images/ZLvsWalkme-check.svg';
import cross from '../images/ZlvsWalkme-X.svg';

// Landing Pages Section 1D
function ZLChartRow(props) {
    return (
        <Tooltip title={props.title} placement="left" interactive arrow>
            <div className="ziplyne-chart__content__row-pendo">
                <img alt="" src={chartRow} />
                <p className="ziplyne-chart__content__row__title-pendo">
                    {props.title}
                </p>
                <div className="ziplyne-chart__content__row__ziplyne-info-pendo">
                    <img alt="" src={check} />
                </div>
                <div className="ziplyne-chart__content__row__other-info-pendo">
                    <img alt="" src={props.checkOther ? check : cross} />
                </div>
            </div>
        </Tooltip>
    );
}

export default ZLChartRow;